import SmsVerifier from './SmsVerifier.vue'
import Vue from 'vue'

let SmsVerifierInstance

SmsVerifier.newIns = properties => {
  const _props = properties || {};
  const Instance = new Vue({
    name: 'SmsVerifier',
    data: Object.assign({
      show: false,
      mobile: null,
      code: null
    }, _props),
    render (h) {
      if (this.render) {
        return h('div', {
        }, [this.render(h)])
      } else {
        // console.log(this.show, this.mobile)
        return h(SmsVerifier, {
          props: {
            show: this.show,
            mobile: this.mobile
          },
          on: {
            'on-submit': (e) => {
              this.onSubmit(e)
            },
            'on-cancel': (e) => {
              this.show = false
              this.mobile = null
              this.code = null
              this.onCancel(e)
            }
          }
        }, [])
      }
    },
    methods: {
      close () {
        this.show = false
      },
      showModal () {
        this.show = true
      }
    }
  })
  const component = Instance.$mount()
  document.body.appendChild(component.$el)
  const verifier = Instance.$children[0]
  return {
    show (props) {
      if ('show' in props) {
        verifier.$parent.show = props.show
      }
      if ('mobile' in props) {
        verifier.$parent.mobile = props.mobile
      }
      if ('onCancel' in props) {
        verifier.$parent.onCancel = props.onCancel;
      }

      if ('onSubmit' in props) {
        // console.log('onSubmit', props.onSubmit)
        verifier.$parent.onSubmit = props.onSubmit
      }
    }
  }
}

function getSmsVerifierInstance (props) {
  SmsVerifierInstance = SmsVerifierInstance || SmsVerifier.newIns(props)
  return SmsVerifierInstance
}

SmsVerifier.show = function (props = {}) {
  // console.log('sms verifier show', props)
  props.show = true
  const render = ('render' in props) ? props.render : undefined;
  let ins = getSmsVerifierInstance({
    show: props.show || true,
    mobile: props.mobile || null,
    onSubmit: props.onSubmit || null,
    onCancel: props.onCancel || null,
    render
  })
  ins.show({
    show: props.show || true,
    mobile: props.mobile || null,
    onSubmit: props.onSubmit || null,
    onCancel: props.onCancel || null
  })
}

export default SmsVerifier